import { IPv8API } from '../ipv8/IPv8API'
import { VerifieeService } from '../ipv8/VerifieeService'
import { AttestationClient } from './AttestationClient'

/** Creates an Attestation Client with all necessary dependencies. */
export class AttestationClientFactory {
    constructor(private config: AttestationClientConfig, private time = Date.now) { }

    public create() {
        const api = new IPv8API(this.config.ipv8_url)
        const verifieeService = new VerifieeService(api, this.time)
        const { mid_b64 } = this.config;
        return new AttestationClient({ mid_b64 }, api, verifieeService)
    }
}

export interface AttestationClientConfig {
    ipv8_url: string
    mid_b64: string
}
